import { createSlice } from "@reduxjs/toolkit";

const uiSlice = createSlice({
  name: "ui",
  initialState: {
    showLoginModal: false,  // controls visibility of login modal
    isChatBoxOpen: false,   // controls visibility of chat box
  },
  reducers: {
    // Show or hide login modal
    showLoginModal: (state, action) => {
      state.showLoginModal = action.payload;
    },

    // Explicitly open/close chat box (pass true/false)
    toggleChatBox: (state, action) => {
      state.isChatBoxOpen = action.payload;
    },

    // Toggle chat box without payload (just flips state)
    toggleChatBoxState: (state) => {
      state.isChatBoxOpen = !state.isChatBoxOpen;
    },
  },
});

// Export actions and reducer
export const { showLoginModal, toggleChatBox, toggleChatBoxState } = uiSlice.actions;
export default uiSlice.reducer;
